// assets/collection-filter.js
import CollectionSidebar from '@archetype-themes/scripts/modules/collection-sidebar'

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector("[data-collection-grid]")) return;
    let form = document.querySelector(".filter-form"); // tagsForm
    const grid = document.querySelector("[data-collection-grid]");
    const productGrid = document.querySelector(".products-grid");
    const productCountElement = document.querySelector(
      window.innerWidth <= 768
      ? "[data-collection-count]"
      : ".collection-filter__item--count"
    );
    // const sortSelect = document.querySelector("[data-default-sortby]");
    const sortSelect = document.querySelector("[data-default-sortby]");

    // Safe value setter
    function getSortValue() {
      if (!sortSelect) return "manual";
      return sortSelect.value || sortSelect.getAttribute("data-default-sortby") || "manual";
    }
    let mobileFiltersInPlace = false;
    let sidebar = document.querySelector('#CollectionSidebar');
    let filterBar = document.querySelector('.collection-filter');
    let filtersWrapper = document.querySelector('.filter-wrapper'); // filters
    let sidebarWrapper = document.querySelector('#CollectionSidebarFilterWrap');
    let inlineWrapper = document.querySelector('#CollectionInlineFilterWrap');

    const inStockCheckbox = document.querySelector('#tagInput-filter\\.v\\.availability-1');
    const outOfStockCheckbox = document.querySelector('#tagInput-filter\\.v\\.availability-2');
    let priceRangeElement = document.querySelector('.price-range');
    let minPriceInput, maxPriceInput;
    let currentMinPrice = 0;
    let currentMaxPrice = 7109.99;

    // Pagination settings
    const productsPerPage = 32; // Number of products to show per page
    let currentPage = 1;
    let filteredProducts = [];
    let allProducts = [];
    let totalProductsFetched = 0;

    // Performance optimization variables
    let isLoading = false;
    const productCache = new Map(); // Cache for products by filter key
    const sizeRangeCache = new Map(); // Cache for expanded size ranges
    const inchesCache = {}; // Cache for inch conversions

    const fetchPageSize = 250; // Max products per page (Shopify API limit)
    let fetchCurrentPage = 1;
    let isProductFetchingComplete = false;
    let isFetchingInProgress = false;
    let fetchRetryCount = 0; // Yeh line add karo top pe

    function showLoading() {
      isLoading = true;
      if (productGrid) {
        // console.log('DEBUG: Loading...');
        const loadingElement = document.createElement('div');
        loadingElement.className = 'loading-indicator';
        loadingElement.innerHTML = '<div class="loading-spinner"></div><div>Loading products...</div>';
        productGrid.innerHTML = '';
        if (window.getComputedStyle(productGrid).position === 'static') {
          productGrid.style.position = 'relative';
          productGrid.style.height = '400px';
        }
        productGrid.appendChild(loadingElement);
      }
    }

    // Hide loading state
    function hideLoading() {
      isLoading = false;
      const loadingElement = document.querySelector('.loading-indicator');
      if (loadingElement) {
        // console.log("DEBUG: Loading complete.");
        productGrid.style.position = 'static';
        productGrid.style.height = '100%';
        loadingElement.remove();
      }
    }

    function cloneFiltersOnMobile() {
      if (window.innerWidth > 768) {
        return;
      }
      if (mobileFiltersInPlace) {
        return;
      }
      if (!sidebarWrapper) {
        return;
      }
      const filtersWrapperEl = sidebarWrapper.querySelector('.filter-wrapper').cloneNode(true);
      inlineWrapper.innerHTML = '';
      inlineWrapper.append(filtersWrapperEl);

      form = filtersWrapperEl.querySelector(".filter-form");

      form.querySelectorAll("input").forEach((input) => {
        input.addEventListener("change", () => {
          currentPage = 1;
          
          showLoading();
          
          // Wait for product fetching to complete before applying filters
          const checkFetchingInterval = setInterval(() => {
            if (isProductFetchingComplete) {
              clearInterval(checkFetchingInterval);
              updateActiveFilters();
              sidebar.close();
            }
          }, 500);
          
        });
      });

      mobileFiltersInPlace = true;
    }

    // Sorting options
    const SORT_OPTIONS = {
      "best-selling": (a, b) => b.sold_count - a.sold_count,
      "title-ascending": (a, b) => a.title.localeCompare(b.title),
      "title-descending": (a, b) => b.title.localeCompare(a.title),
      "price-ascending": (a, b) =>
        parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price),
      "price-descending": (a, b) =>
        parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price),
      "created-ascending": (a, b) =>
        new Date(a.created_at) - new Date(b.created_at),
      "created-descending": (a, b) =>
        new Date(b.created_at) - new Date(a.created_at),
    };

    // Size range mapping with dynamic range processing
    const SIZE_RANGES = {
      "Size 1x1-2.5x14": [],
      "Size 2.6x6-2.7x20": [],
      "Size 3x1-3.7x15": [],
      "Size 4x1-4.11x14": [],
      "Size 5x5-5.9x15": [],
      "Size 6x6-6.8x15": [],
      "Size 7x7-7.11x15": [],
      "Size 8x8-8.10x16": [],
      "Size 9x9-9.9x15": [],
      "Size 10x10-10.5x16": [],
      "Size 11x11-11.6x15": [],
      "Size 12x12-12.5x16": [],
    };

    //====================================================
    // CONVERT TO INCHES
    //====================================================

    function convertToInches(sizeStr) {
      if (inchesCache[sizeStr] !== undefined) {
        return inchesCache[sizeStr];
      }

      const [feet, inches] = sizeStr.split(".").map(Number);
      const result = feet * 12 + (inches || 0);
      inchesCache[sizeStr] = result;
      return result;
    }

    //====================================================
    // SIZE FILTER RANGE
    //====================================================

    function expandSizeRanges(sizeFilters) {
      // Create a cache key from the filter list
      const cacheKey = sizeFilters.sort().join(",");

      // Check cache first
      if (sizeRangeCache.has(cacheKey)) {
        return sizeRangeCache.get(cacheKey);
      }

      let expandedSizes = [...sizeFilters];

      // For each size filter, check if it's a range and add the individual sizes
      sizeFilters.forEach((sizeFilter) => {
        // Handle explicit range format "Size AxB-CxD"
        if (sizeFilter.includes("-")) {
          const rangeMatch = sizeFilter.match(
            /[Ss]ize (\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/
          );
          if (rangeMatch) {
            const [, startWidth, startHeight, endWidth, endHeight] = rangeMatch;

            // Convert range boundaries once
            const startWidthInches = convertToInches(startWidth);
            const startHeightInches = convertToInches(startHeight);
            const endWidthInches = convertToInches(endWidth);
            const endHeightInches = convertToInches(endHeight);

            // Process product tags more efficiently - collect all size tags first
            const sizeTags = new Set();
            allProducts.forEach((product) => {
              if (!product.tags) return;

              product.tags.forEach((tag) => {
                // Check if the tag is a size tag (starts with "Size ")
                if (tag.startsWith("Size ") || tag.startsWith("size ")) {
                  sizeTags.add(tag);
                }
              });
            });

            // Process unique size tags once
            sizeTags.forEach((tag) => {
              // Extract dimensions from the tag
              const sizeMatch = tag.match(
                /[Ss]ize (\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/
              );
              if (sizeMatch) {
                const [, width, height] = sizeMatch;

                // Check if dimensions are within the range
                const widthInches = convertToInches(width);
                const heightInches = convertToInches(height);

                if (
                  widthInches >= startWidthInches &&
                  widthInches <= endWidthInches &&
                  heightInches >= startHeightInches &&
                  heightInches <= endHeightInches
                ) {
                  if (!expandedSizes.includes(tag)) {
                    expandedSizes.push(tag);
                  }
                }
              }

              // Handle special size types like oval
              const specialSizeMatch = tag.match(
                /[Ss]ize (\d+(?:\.\d+)?)x(\d+(?:\.\d+)?) (\w+)/
              );
              if (specialSizeMatch) {
                const [, width, height] = specialSizeMatch;

                // Check if dimensions are within the range
                const widthInches = convertToInches(width);
                const heightInches = convertToInches(height);

                if (
                  widthInches >= startWidthInches &&
                  widthInches <= endWidthInches &&
                  heightInches >= startHeightInches &&
                  heightInches <= endHeightInches
                ) {
                  if (!expandedSizes.includes(tag)) {
                    expandedSizes.push(tag);
                  }
                }
              }
            });
          }
        }
        // Handle specific sizes listed in SIZE_RANGES
        else if (SIZE_RANGES[sizeFilter]) {
          expandedSizes = [...expandedSizes, ...SIZE_RANGES[sizeFilter]];
        }
      });

      // Cache the result
      sizeRangeCache.set(cacheKey, expandedSizes);
      return expandedSizes;
    }

    //====================================================
    // Initialize from URL parameters
    //====================================================
    
    function initializeFromURL() {
      const params = new URLSearchParams(window.location.search);

      // Set initial page
      currentPage = parseInt(params.get("page")) || 1;

      // Set initial sort
      const sortBy = params.get("sort_by") || "manual";
      if (sortSelect && sortSelect.value !== undefined) {
        sortSelect.value = sortBy;
      }

      // Set initial filters
      const filterTypes = [
        "size",
        "color",
        "material",
        "design",
        "shape",
        "collection",
        "construction",
        "pile",
        "in-stock",
      ];
      filterTypes.forEach((type) => {
        const values = params.getAll(`filter.${type}`);
        if (values.length) {
          values.forEach((value) => {
            const checkbox = form.querySelector(
              `input[name="${type}[]"][value="${value}"]`
            );
            if (checkbox) checkbox.checked = true;
          });
        }
      });

      // Set availability filters
      const availabilityValues = params.getAll('filter.availability');
      if (inStockCheckbox) {
        inStockCheckbox.checked = availabilityValues.includes('in_stock');
      }
      if (outOfStockCheckbox) {
        outOfStockCheckbox.checked = availabilityValues.includes('out_of_stock');
      }
      
      // Set price range filters
      const minPrice = params.get('filter.price.min');
      const maxPrice = params.get('filter.price.max');
      
      if (priceRangeElement && priceRangeElement.noUiSlider) {
        const minValue = minPrice ? parseFloat(minPrice) : parseFloat(priceRangeElement.dataset.min || 0);
        const maxValue = maxPrice ? parseFloat(maxPrice) : parseFloat(priceRangeElement.dataset.max || 7109.99);
        
        priceRangeElement.noUiSlider.set([minValue, maxValue]);
        currentMinPrice = minValue;
        currentMaxPrice = maxValue;
      }
    }

    //====================================================
    // Update URL with current filters and sort
    //====================================================
    
    function updateURL() {
      const params = new URLSearchParams();

      // Add page parameter
      if (currentPage > 1) {
        params.set("page", currentPage);
      }

      // Add sort parameter
      const currentSort = getSortValue();
      if (currentSort && currentSort !== "best-selling") {
        params.set("sort_by", currentSort);
      }

      // Add filter parameters
      if (!form) return;
      const formData = new FormData(form);
      for (const [key, value] of formData.entries()) {
        if (value) {
          const filterName = key.replace("[]", "");
          params.append(`filter.${filterName}`, value);
        }
      }

      // Add availability filters
      if (inStockCheckbox && inStockCheckbox.checked) {
        params.append("filter.availability", "in_stock");
      }
      if (outOfStockCheckbox && outOfStockCheckbox.checked) {
        params.append("filter.availability", "out_of_stock");
      }
      
      // Add price range if changed from default
      if (currentMinPrice > 0) {
        params.append("filter.price.min", currentMinPrice);
      }
      if (currentMaxPrice < parseFloat(priceRangeElement?.dataset.max || 7109.99)) {
        params.append("filter.price.max", currentMaxPrice);
      }

      // Update URL without reloading
      const newURL = `${window.location.pathname}${
        params.toString() ? "?" + params.toString() : ""
      }`;
      window.history.pushState({ path: newURL }, "", newURL);
      // console.log("DEBUG: ", newURL);
    }

    //====================================================
    // Fetch all products
    //====================================================

    async function fetchAllProducts() {
      
      isFetchingInProgress = true;
      
      if (hasUrlParameters()) {
        showLoading();
      }
      
      let url = `${window.location.pathname}/products.json?limit=${fetchPageSize}&page=${fetchCurrentPage}`;
      try {
        let response;
        do {
          response = await fetch(url);
          const data = await response.json();

          allProducts = [...allProducts, ...data.products];
          totalProductsFetched += data.products.length;

          fetchCurrentPage++;

          if (data.products.length < fetchPageSize) {
            break;
          }

          url = `${window.location.pathname}/products.json?limit=${fetchPageSize}&page=${fetchCurrentPage}`;
        } while (response.ok && response.status === 200);

        // console.log("DEBUG: All products fetched:", allProducts.length);
        filteredProducts = allProducts;
        
        isProductFetchingComplete = true;
        isFetchingInProgress = false;

        hideLoading();
        
        if (hasUrlParameters()) {
          initializeFromURL();
          updateActiveFilters();
        }
        } catch (error) {
        console.error("Fetch failed:", error);
        if (fetchRetryCount < 3) {
          fetchRetryCount++;
          console.log(`Retry attempt ${fetchRetryCount}...`);
          setTimeout(() => {
            fetchCurrentPage = 1;
            allProducts = [];
            fetchAllProducts();
          }, 2000 * fetchRetryCount);
        } else {
          if (grid) {
            grid.innerHTML =
              '<div class="error-message">Error loading products. Please try again.</div>';
          }
        }
        isFetchingInProgress = false;
      }
    }

    //====================================================
    // Get active filter lists
    //====================================================

    function getActiveFilters() {
      if (!form) return;
      const formData = new FormData(form);
      const filters = {};

      [
        "color",
        "material",
        "design",
        "shape",
        "collection",
        "construction",
        "pile",
        "in-stock",
      ].forEach((filterType) => {
        const values = formData.getAll(`${filterType}[]`);
        if (values.length) {
          filters[filterType] = values;
        }
      });

      // Handle size filters
      const sizeValues = formData.getAll("size[]");
      if (sizeValues.length) {
        filters.size = sizeValues;
      }

      const availability = [];
      if (inStockCheckbox && inStockCheckbox.checked) availability.push('in_stock');
      if (outOfStockCheckbox && outOfStockCheckbox.checked) availability.push('out_of_stock');
      if (availability.length) filters.availability = availability;
    
      // Add price range filter
      if (currentMinPrice > 0 || currentMaxPrice < parseFloat(priceRangeElement?.dataset.max || 7109.99)) {
        filters.price = {
          min: currentMinPrice,
          max: currentMaxPrice
        };
      }

      return filters;
    }

    //====================================================
    // Update total products count
    //====================================================

    function updateProductCount(count) {
      if (productCountElement) {
        productCountElement.textContent = `${count} products`;
      }
    }

    //====================================================
    // Sort products
    //====================================================
    
    function sortProducts(products, sortBy) {
      const sortFn = SORT_OPTIONS[sortBy];
      return sortFn ? [...products].sort(sortFn) : products;
    }

    //====================================================
    // Apply filter and sort products
    //====================================================
    
    function applyFiltersAndSort() {
      // console.log("DEBUG: Applying filters");
      if (!form) return;
      const formData = new FormData(form);
      const filters = {};

      [
        "color",
        "material",
        "design",
        "shape",
        "collection",
        "construction",
        "pile",
        "in-stock",
      ].forEach((filterType) => {
        const values = formData.getAll(`${filterType}[]`);
        if (values.length) {
          filters[filterType] = values;
        }
      });

      // Handle size filters specially to expand ranges
      const sizeValues = formData.getAll("size[]");
      if (sizeValues.length) {
        filters.size = expandSizeRanges(sizeValues);
      }

      filteredProducts = allProducts.filter((product) => {
        // console.log("Product:", product.title);
        // console.log("Has variants:", !!product.variants);
        // console.log("Variants length:", product.variants?.length);
        
        // if (product.variants) {
        //   product.variants.forEach((variant, index) => {
        //     console.log(`Variant ${index}:`, {
        //       id: variant.id,
        //       inventory_management: variant.inventory_management,
        //       inventory_quantity: variant.inventory_quantity,
        //       inventory_policy: variant.inventory_policy,
        //       available: variant.available
        //     });
        //   });
        // }
        return Object.entries(filters).every(([filterType, filterValues]) => {
          switch (filterType) {
            case "size":
            case "color":
            case "design":
            case "material":
            case "shape":
            case "collection":
            case "construction":
            case "pile":
              // A product matches if it has ANY of the selected tags for this filter type
              return filterValues.some(
                (value) => product.tags && product.tags.includes(value)
              );
            case "product_type":
              return filterValues.some(
                (value) => product.product_type && product.product_type === value
              );
            case "in-stock":
              return (
                product.tags &&
                product.tags.includes("In Stock") &&
                filterValues.some((value) => {
                  if (!product.tags.includes(value)) return false;
              
                  const size = value.replace("Size ", "").trim();
                  return product.variants.some(variant => 
                    variant.option1 === size && variant.available
                  );
                })
              );
              // return product.tags &&
              //   product.tags.includes("In Stock") &&
              //   filterValues.some((value) => product.tags.includes(value)) &&
              //   product.variants.some(variant => variant.available);
            case "availability":
              // If both are checked or none are checked, show all
              if (filterValues.length === 2 || filterValues.length === 0) return true;
              
              // Check variant availability
              const isInStock = product.variants.some(variant => variant.available);
              
              // Check if product matches selected availability
              if (filterValues.includes('in_stock') && isInStock) return true;
              if (filterValues.includes('out_of_stock') && !isInStock) return true;
              
              return false;
            case "price":
              // Get lowest price among all variants
              let productPrice = Infinity;
              product.variants.forEach(variant => {
                const price = parseFloat(variant.price);
                if (price < productPrice) productPrice = price;
              });
              
              return productPrice >= filterValues.min && productPrice <= filterValues.max;
            default:
              return filterValues.some(
                (value) =>
                  product[filterType] && product[filterType].includes(value)
              );
          }
        });
      });

      filteredProducts = sortProducts(filteredProducts, getSortValue());

      // Update URL with new state
      updateURL();

      // Update product count
      updateProductCount(filteredProducts.length);
      
      setTimeout(() => {
        // Stop loading spinner
        hideLoading();
        // Display products
        displayProductsForCurrentPage();
      }, 500);
    }

    // Add this HTML where you want to display active filters
    const activeFiltersContainer = document.createElement("div");
    activeFiltersContainer.className = "active-filters";
    if (form) {
      form.insertAdjacentElement("beforebegin", activeFiltersContainer);
    }
    //====================================================
    // Display & Update active filter lists
    //====================================================

    function updateActiveFilters() {
      
      if (!form) return;
      const formData = new FormData(form);
      const activeFilters = [];

      [
        "size",
        "color",
        "material",
        "design",
        "shape",
        "collection",
        "construction",
        "pile",
        "in-stock",
      ].forEach((filterType) => {
        const values = formData.getAll(`${filterType}[]`);
        values.forEach((value) => {
          activeFilters.push({
            type: filterType,
            value: value,
          });
        });
      });

      // Add availability filters
      if (inStockCheckbox && inStockCheckbox.checked) {
        activeFilters.push({
          type: "availability",
          value: "In stock"
        });
      }
      if (outOfStockCheckbox && outOfStockCheckbox.checked) {
        activeFilters.push({
          type: "availability",
          value: "Out of stock"
        });
      }
      
      // Add price range filter if not at default values
      if (currentMinPrice > 0 || currentMaxPrice < parseFloat(priceRangeElement?.dataset.max || 7109.99)) {
        activeFilters.push({
          type: "price",
          value: `$${currentMinPrice.toFixed(2)} - $${currentMaxPrice.toFixed(2)}`
        });
      }

      // Generate HTML for active filters
      if (activeFilters.length > 0) {
        const html = `
          <ul class="no-bullets tag-list tag-list--active-tags">
            ${activeFilters
              .map(
                (filter) => `
              <li class="tag tag--remove">
                <a href="#" class="btn btn--small js-no-transition" data-filter-type="${filter.type}" data-filter-value="${filter.value}">
                  ${filter.value}
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64" width="12" height="12">
                  <path d="M19 17.61l27.12 27.13m0-27.13L19 44.74" fill="none" stroke="currentColor" stroke-width="2"/>
                </svg>
              </li>
            `
              )
              .join("")}
          </ul>
        `;
        activeFiltersContainer.innerHTML = html;

        // Add event listeners to remove links
        const removeLinks = activeFiltersContainer.querySelectorAll(".tag--remove a");
        removeLinks.forEach((link) => {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            const filterType = e.currentTarget.dataset.filterType;
            const filterValue = e.currentTarget.dataset.filterValue;

            const checkbox = form.querySelector(
              `input[name="${filterType}[]"][value="${filterValue}"]`
            );
            if (checkbox) {
              checkbox.checked = false;

              const tagElement = e.currentTarget.closest(".tag--remove");
              if (tagElement) {
                tagElement.remove();
              }
              
              showLoading();
              
              // console.log("DEBUG: Remove Filter");
              applyFiltersAndSort();
            }
          });
        });
      } else {
        // console.log("DEBUG: Active filter not found");
        activeFiltersContainer.innerHTML = "";
      }
      
      applyFiltersAndSort();
      // console.log("DEBUG: After load complete.")
    }

    //====================================================
    // Check if URL has filter parameters
    //====================================================

    function hasUrlParameters() {
      const params = new URLSearchParams(window.location.search);
      return Array.from(params.keys()).some(
        (key) => key.startsWith("filter.") || key === "sort_by" || key === "page"
      );
    }

    //====================================================
    // Initialize the page
    //====================================================
    
    if (form && grid) {
      // Fetch initial products
      fetchAllProducts();

      // Initialize price range filter
      // customElements.whenDefined('price-range').then(() => {
      //   requestIdleCallback(() => {
      //     initializePriceRangeFilter();
      //   });
      // });

      
      // Initialize availability filter
      initializeAvailabilityFilter();

      form.querySelectorAll("input").forEach((input) => {
        input.addEventListener("change", () => {
          currentPage = 1;
          
          showLoading();
          
          // Wait for product fetching to complete before applying filters
          const checkFetchingInterval = setInterval(() => {
            if (isProductFetchingComplete) {
              clearInterval(checkFetchingInterval);
              updateActiveFilters();
            }
          }, 500);
          
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener("change", () => {
          currentPage = 1;
          applyFiltersAndSort();
        });
      }

      // Handle browser back/forward
      window.addEventListener("popstate", () => {
        initializeFromURL();
        applyFiltersAndSort();
      });

      cloneFiltersOnMobile();
      sidebar = new CollectionSidebar();
    }

    //====================================================
    // Generate pagination after filter applies
    //====================================================

    function generatePaginationHTML(totalPages) {
      const baseUrl = window.location.origin + window.location.pathname;
      let html = '<div class="pagination">';

      // Previous button
      if (currentPage > 1) {
        html += `
          <span class="prev">
            <a href="#" data-page="${
              currentPage - 1
            }" title="Previous" class="btn btn--large btn--circle btn--icon">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98" fill="currentColor" width="20" height="20">
                <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.5 249.49l189.74 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0"></path>
              </svg>
              <span class="icon__fallback-text visually-hidden">Previous</span>
            </a>
          </span>
        `;
      }

      // Page numbers
      for (let i = 1; i <= totalPages; i++) {
        if (
          i === 1 ||
          i === totalPages ||
          (i >= currentPage - 2 && i <= currentPage + 2)
        ) {
          if (i === currentPage) {
            html += `<span class="page current">${i}</span>`;
          } else {
            html += `
              <span class="page">
                <a href="${baseUrl}?page=${i}" data-page="${i}">${i}</a>
              </span>
            `;
          }
        } else if (
          (i === currentPage - 3 && currentPage > 4) ||
          (i === currentPage + 3 && currentPage < totalPages - 3)
        ) {
          html += '<span class="page">…</span>';
        }
      }

      // Next button
      if (currentPage < totalPages) {
        html += `
          <span class="next">
            <a href="#" data-page="${
              currentPage + 1
            }" title="Next" class="btn btn--large btn--circle btn--icon">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98" fill="currentColor" width="20" height="20">
                <path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98"></path>
              </svg>
              <span class="icon__fallback-text visually-hidden">Next</span>
            </a>
          </span>
        `;
      }

      html += "</div>";
      return html;
    }

    //====================================================
    // Pagination
    //====================================================

    function attachPaginationEventListeners() {
      const paginationLinks = document.querySelectorAll(
        ".pagination a[data-page]"
      );
      paginationLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          currentPage = parseInt(e.currentTarget.dataset.page);
          updateURL();
          displayProductsForCurrentPage();
          // Scroll to top of grid
          grid.scrollIntoView({ behavior: "smooth" });
        });
      });
    }

    //====================================================
    // Display fetched products
    //====================================================

    function displayProductsForCurrentPage() {
      const startIndex = (currentPage - 1) * productsPerPage;
      const endIndex = startIndex + productsPerPage;
      const productsToShow = filteredProducts.slice(startIndex, endIndex);

      if (!productGrid) return;

      // Generate HTML for products and pagination
      let gridHTML = "";

      if (productsToShow.length === 0) {
        gridHTML =
          `<div class="no-products-message">
            <div class="no-products-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="icon-bag icon--line"
                viewBox="0 0 64 64"
                width="64"
                height="64"
              >
                <path
                  d="M24.23 18c0-7.75 3.92-14 8.75-14s8.74 6.29 8.74 14m-26.98 0h36.51l3.59 36.73h-43.7Z"
                  fill="none"
                  stroke="#aaa"
                />
              </svg>
            </div>
            <p><strong>No Products Found</strong></p>
            <p>Please try changing the filters or come back later.</p>
          </div>`;
      } else {
        // Add products
        gridHTML = productsToShow
          .map((product) => generateProductCard(product))
          .join("");

        // Add pagination after products
        const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
        gridHTML += generatePaginationHTML(totalPages);
      }

      // Update the grid
      productGrid.innerHTML = gridHTML;

      // Attach event listeners to new pagination buttons
      attachPaginationEventListeners();
    }

    //====================================================
    // Product card layout
    //====================================================

    function generateProductCard(product) {
      const imageUrl = product.images[0]?.src || "default-image-url";
      const existingCard = document.querySelector(
        `[data-product-id="${product.id}"]`
      );
      const customLabel = existingCard?.dataset.customLabel || "";
      const reviewsCount = existingCard?.dataset.reviewsCount || "0";
      const rating = existingCard?.dataset.rating || "0";

      // Check if there are multiple variants
      const hasMultipleVariants = product.variants && product.variants.length > 1;

      // Sort variants by price
      let sortedVariants = [...product.variants];
      if (hasMultipleVariants) {
        sortedVariants.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      }

      // Get lowest and highest price variants
      const lowestVariant = sortedVariants[0];
      const highestVariant = sortedVariants[sortedVariants.length - 1];

      // Format prices
      const lowestPrice = lowestVariant
        ? parseFloat(lowestVariant.price).toFixed(2)
        : "0.00";
      const highestPrice = highestVariant
        ? parseFloat(highestVariant.price).toFixed(2)
        : "0.00";

      // Determine price display
      let priceDisplay;
      if (!hasMultipleVariants || lowestPrice === highestPrice) {
        priceDisplay = formatMoney(lowestPrice);
      } else {
        priceDisplay = `${formatMoney(lowestPrice)} - ${formatMoney(
          highestPrice
        )}`;
      }

      // Check for discounts and prepare compare at price display
      let hasDiscount = false;
      let lowestComparePrice = null;
      let highestComparePrice = null;

      for (const variant of sortedVariants) {
        if (
          variant.compare_at_price &&
          parseFloat(variant.compare_at_price) > parseFloat(variant.price)
        ) {
          hasDiscount = true;

          const comparePrice = parseFloat(variant.compare_at_price).toFixed(2);

          // Track lowest compare price
          if (lowestComparePrice === null || comparePrice < lowestComparePrice) {
            lowestComparePrice = comparePrice;
          }

          // Track highest compare price
          if (
            highestComparePrice === null ||
            comparePrice > highestComparePrice
          ) {
            highestComparePrice = comparePrice;
          }
        }
      }

      // Build compare at price display if needed
      let compareAtPriceDisplay = "";
      if (hasDiscount) {
        if (lowestComparePrice === highestComparePrice) {
          compareAtPriceDisplay = `<span class="grid-product__price--original">${formatMoney(
            lowestComparePrice
          )}</span>`;
        } else {
          compareAtPriceDisplay = `<span class="grid-product__price--original">${formatMoney(
            highestComparePrice
          )} - ${formatMoney(lowestComparePrice)}</span>`;
        }
      }

      // Check availability
      const isAvailable = sortedVariants.some((variant) => variant.available);
      const availability = isAvailable ? "In stock" : "Sold out";

      return `
        <div class="grid-item grid-product grid-product-image-breathing-room--false">
          <div class="product-grid-item" data-product-handle="${
            product.handle
          }" data-product-id="${product.id}" data-product-grid-item="" data-custom-label="${customLabel}" data-reviews-count="${reviewsCount}" data-rating="${rating}">
              <div class="grid-item__content">
                  <div class="grid-product__actions">
                      <is-land on:idle="" ready="">
                        <quick-shop>
                          <tool-tip-trigger class="tool-tip-trigger" data-tool-tip="QuickShop" data-tool-tip-classes="quick-shop-modal">
                            <span class="tool-tip-trigger__content" data-tool-tip-trigger-content=""></span>
                      
                            <button type="button" class="btn btn--circle btn--icon quick-product__btn js-modal-open-quick-modal-6718726045830 small--hide" title="Quick shop" data-handle="${
                              product.handle
                            }">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-search icon--line" viewBox="0 0 64 64" width="20" height="20">
                                <path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58M54 54 41.94 42" stroke-miterlimit="10" fill="none" stroke="currentColor"></path>
                              </svg>
                      
                              <span class="icon__fallback-text visually-hidden">Quick shop</span>
                            </button>
                          </tool-tip-trigger>
                      
                          <script type="module">
                            import 'components/tool-tip-trigger'
                          </script>
                        </quick-shop>
                      
                        <script type="module">
                          import 'components/quick-shop'
                        </script>
                      </is-land>
                      <is-land on:idle="" ready="">
                        <quick-add>
                          <tool-tip-trigger class="tool-tip-trigger" data-tool-tip="QuickAdd" data-tool-tip-classes="quick-add-modal">
                            <span class="tool-tip-trigger__content" data-tool-tip-trigger-content=""></span>
                      
                            <button type="button" class="text-link quick-add-btn js-quick-add-form js-modal-open-quick-add" title="Add to cart">
                              <span class="btn btn--circle btn--icon">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus icon--line" viewBox="0 0 64 64" width="20" height="20">
                                  <path d="M32 9v46m23-23H9" fill="none" stroke="currentColor"></path>
                                </svg>
                      
                                <span class="icon__fallback-text visually-hidden">Add to cart</span>
                              </span>
                            </button>
                          </tool-tip-trigger>
                      
                          <script type="module">
                            import 'components/tool-tip-trigger'
                          </script>
                        </quick-add>
                      
                        <script type="module">
                          import 'components/quick-add'
                        </script>
                      </is-land>
                  </div>
                  <a href="/products/${product.handle}" class="grid-item__link">
                      <div class="grid-product__image-wrap">
                        ${
                          hasDiscount
                            ? `
                        <div class="grid-product__tags">
                          <div class="grid-product__tag grid-product__tag--sale">Sale</div>
                        </div>`
                            : ""
                        }
                        <div class="grid__image-ratio grid__image-ratio--square">
                          <img src="${imageUrl}" alt="${product.title}" class=" grid__image-contain image-style--square image-element" loading="lazy" data-animate="fadein"/>
                        </div>
                      </div>
                      <div class="grid-item__meta">
                          <div class="grid-item__meta-main">
                              <div class="grid-product__title">${
                                product.title
                              }</div>
                              <div class="loox-rating" data-id="${
                                product.id
                              }" data-rating="${rating}" data-raters="${reviewsCount}"></div>
                          </div>
                          <div class="grid-item__meta-secondary">
                              <div class="grid-product__price">
                                  <span class="grid-product__price--current">
                                      <span aria-hidden="true" class="grid-product__price--from">
                                        ${priceDisplay}
                                      </span>
                                  </span>
                                  ${compareAtPriceDisplay}
                              </div>
                          </div>
                      </div>
                  </a>
              </div>
          </div>
      </div>
      `;
    }
    
    //====================================================
    // Initialize price range slider
    //====================================================
    
    function initializePriceRangeFilter() {
      if (!priceRangeElement) return;
      
      // Get price range elements
      const priceSlider = priceRangeElement.querySelector('.noUi-target');
      minPriceInput = priceRangeElement.querySelector('.price-range__input-min');
      maxPriceInput = priceRangeElement.querySelector('.price-range__input-max');
      
      if (!priceSlider || !priceSlider.noUiSlider) return;

      // Get min and max values
      const minPriceDefault = parseFloat(priceRangeElement.dataset.min || 0);
      const maxPriceDefault = parseFloat(priceRangeElement.dataset.max || 7109.99);
      
      // Initialize price values
      currentMinPrice = minPriceDefault;
      currentMaxPrice = maxPriceDefault;
      
      // Add event listeners for price range updates
      priceSlider.noUiSlider.on('update', function(values) {
        currentMinPrice = parseFloat(values[0]);
        currentMaxPrice = parseFloat(values[1]);
        
        // Update input fields for form submission
        if (minPriceInput) minPriceInput.value = currentMinPrice;
        if (maxPriceInput) maxPriceInput.value = currentMaxPrice;
        
        // Apply filters with debounce to avoid excessive calls
        clearTimeout(window.priceFilterTimeout);
        window.priceFilterTimeout = setTimeout(() => {
          currentPage = 1;
          applyFiltersAndSort();
        }, 500);
      });
    }

    //====================================================
    // Add availability event listeners to your initialization section
    //====================================================
    
    function initializeAvailabilityFilter() {
      if (inStockCheckbox) {
        inStockCheckbox.addEventListener('change', () => {
          currentPage = 1;
          showLoading();
          
          // Wait for product fetching to complete before applying filters
          const checkFetchingInterval = setInterval(() => {
            if (isProductFetchingComplete) {
              clearInterval(checkFetchingInterval);
              applyFiltersAndSort();
            }
          }, 500);
        });
      }
      
      if (outOfStockCheckbox) {
        outOfStockCheckbox.addEventListener('change', () => {
          currentPage = 1;
          showLoading();
          const checkFetchingInterval = setInterval(() => {
            if (isProductFetchingComplete) {
              clearInterval(checkFetchingInterval);
              applyFiltersAndSort();
            }
          }, 500);
        });
      }
    }

    //====================================================
    // Format money
    //====================================================

    function formatMoney(amount) {
      const parsedAmount = parseFloat(amount); // Ensure it's a number
      if (isNaN(parsedAmount)) {
        return ""; // Return a default value if the input is not a valid number
      }
      return `$${parsedAmount.toFixed(2)}`; // Format the number to 2 decimal places
    }
});
